import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { getTodaysDate, getYesterdaysDate } from 'utils/LocalDateTimeHelper'

import { isLoading, load, get } from '../reducers/meetings';

import GreyhoundRacingResultsForDate from '../components/GreyhoundRacingResultsForDate';

const REFRESH_INTERVAL_MILLIS = 10000;


function convertDate(date)
{
  if(date == 'yesterday') {
    date = getYesterdaysDate("YYYY-MM-DD");
  }
  return date;
}

@standardAsyncConnect([
  {
    dispatch: ({params: {date = getTodaysDate("YYYY-MM-DD")}}) => load(convertDate(date)),
    preventResolve: ({state, params: {date = getTodaysDate("YYYY-MM-DD")}}) => isLoading(state, convertDate(date)),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => ({meetingsByDate: get(state)})
  }
])
@catchLifeCycleErrors
export default class GreyhoundRacingResultsForDateContainer extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    // supplied by react-router via @connect
    params: PropTypes.shape({
      date: PropTypes.string
    }),
    meetingsByDate: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
  };

  render() {
    return (
      <GreyhoundRacingResultsForDate
        routes={this.props.routes}
        date={convertDate(this.props.params.date)}
        meetingsByDate={this.props.meetingsByDate}
        raceType="Greyhounds"/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingResultsForDateContainer.js